import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {Solution} from '../../../../../Models/Solution';
import {Subscription} from 'rxjs';
import {SolutionService} from '../../../../../Services/solution.service';
import {TranslateService} from '@ngx-translate/core';
import {ActionForm} from '../../../../../Models/ActionForm';

@Component({
  selector: 'app-solution-action-form',
  templateUrl: './solution-action-form.component.html',
  styleUrls: ['./solution-action-form.component.scss']
})
export class SolutionActionFormComponent implements OnInit, OnDestroy {
  @Input() Index: number;
  public solution: Solution = new Solution();
  private subscriptions: Subscription[] = [];

  constructor(
    public solutionService: SolutionService,
    public translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.solutionService.solution.subscribe(solution => {
        this.solution = solution;
        if (this.solution.solutionSteps[this.Index] && !this.solution.solutionSteps[this.Index].actionForm) {
          this.solution.solutionSteps[this.Index].actionForm = new ActionForm();
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  updateSolution() {
    this.solutionService.solution.next(this.solution);
  }
}
